<template>
  <div
    class="scrollable phyExService"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <v-header></v-header>
    <div class="content">
      <div class="banner">
        <img src="../../assets/tjBanner.png" />
      </div>
      <div class="mod" style="margin-bottom: 64px; margin-top: 64px">
        <div class="appoPhysical" @click="appoPhysicalTJ">
          <p class="icon">
            <img src="../../assets/icon/预约体检.png" width="50" height="50" />
          </p>
          <p :class="qhText == 'en' ? 'modName staffEn' : 'modName'">
            本人体检
          </p>
          <p id="dsy" v-if="status==0 && invoice_power != 2">
            <img src="../../assets/icon/待使用.png" alt />
          </p>
        </div>
        <div class="appoPhysical" @click="dependentsTJ">
          <p class="icon">
            <img src="../../assets/icon/家属体检.png" width="50" height="50" />
          </p>
          <p class="modName">家属体检</p>
          <p id="dsy" v-if="num">
            <img src="../../assets/icon/待使用.svg" alt />
          </p>
        </div>
        <div class="appoPhysical" @click="tjbg">
          <p class="icon">
            <img src="../../assets/icon/体检报告.png" width="50" height="50" />
          </p>
          <p class="modName">体检报告</p>
          <p id="dsy">
            <!-- <img src="../../assets/icon/gao.png" alt /> -->
          </p>
        </div>
        <div class="appoPhysical" @click="tjPDF">
          <p class="icon">
            <img src="../../assets/icon/健康咨询.png" width="50" height="50" />
          </p>
          <p :class="qhText == 'en' ? 'modName reportEn' : 'modName'">
            <!-- {{ $t("m.phyIndex.medicalReportsModel") }} -->
            健康咨询
          </p>
        </div>
      </div>
      <v-manual></v-manual>
      <!-- <div class="msg" style="padding-bottom:50px;">
        <h3>{{$t('m.phyIndex.phyTit')}}</h3>
        <p>定期健康体检是预防保健，早期发现疾病、亚健康的重要手段，为了保持健康，对疾病能做到早期诊断，及时治疗，应该定期到进行健康检查。这样可以及时了解身体内部的情况，可以及时发现一些重要的疾病，同时可以全面估计自己的健康状况，听取医生的意见和建议，用以指导自己的生活保健。</p>
      </div> -->
    </div>
    <v-footer></v-footer>
    <!-- 选择项目 -->
    <el-dialog
      :title="$t('m.phyIndex.chooseProjectTit')"
      :visible.sync="projectVisible"
      :close-on-click-modal="false"
    >
      <div class="projectMsg">
        <!-- <p class="tit"></p> -->
        <div>
          <p :key="index" v-for="(item, index) in projectList">
            <el-radio v-model="projectRadio" :label="index">{{
              item.name
            }}</el-radio>
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="projectOkBtn">{{
          $t("m.common.define")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 补充员工信息 -->
    <el-dialog
      :title="$t('m.staffMsg.editDialog.titPerfect')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <div class="editMsg">
        <div class="name item">
          <p>{{ $t("m.staffMsg.editDialog.name") }}</p>
          <p>{{ showMsg.name }}</p>
        </div>
        <div class="sex item">
          <p>{{ $t("m.staffMsg.editDialog.sex") }}</p>
          <p>{{ showMsg.gender_value }}</p>
        </div>
        <div class="cardType item">
          <p>{{ $t("m.staffMsg.editDialog.cardType") }}</p>
          <p>
            {{
              showMsg.identity_type == 0
                ? $t("m.common.nationalType.idcard")
                : showMsg.identity_type == 1
                ? $t("m.common.nationalType.passport")
                : showMsg.identity_type == 2
                ? $t("m.common.nationalType.gat")
                : $t("m.common.nationalType.other")
            }}
          </p>
        </div>

        <div class="idcard item">
          <p>{{ $t("m.staffMsg.editDialog.card") }}</p>
          <p>{{ showMsg.identity_code }}</p>
        </div>
        <div class="mobile item" v-if="showMsg.identity_type != 0">
          <p>出生日期</p>
          <el-date-picker
              type="date"
              placeholder="请选择出生日期"
              v-model="showMsg.birthday"
              style="width: 75%;"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
        </div>
        <div class="mobile item" label="婚姻状况" prop="marriage" v-if="showMsg.gender_value == '女'">
          <p>婚姻状况</p>
          <el-radio-group v-model="marriage">
            <el-radio :label="0">未婚</el-radio>
            <el-radio :label="1">已婚</el-radio>
          </el-radio-group>
        </div>
        <div
          v-if="showMsg.gender_value == '女' && marriage != 2"
          class="ts"
          style="margin-bottom: 20px;"
        >
          *婚否信息会影响对应的套餐内容：选择“未婚”，则对应“无妇科检查”套餐，如需要妇科检查，请您选择“已婚”
          （妇科检查仅适用于已婚或未婚有性生活史女性，且孕期不可做）
        </div>
        <div class="mobile item">
          <p>{{ $t("m.staffMsg.editDialog.phone") }}</p>
          <input
            type="text"
            :placeholder="$t('m.staffMsg.editDialog.inputPhone')"
            v-model="showMsg.contacttel"
            maxlength="11"
          />
        </div>
        <!-- <div class="yzm">
            <div class="left"><input
                clearable
                v-model="phoneNum"
                placeholder="验证码"
                style="width: 150pxl;outline: none;"
                width="250px"
              ></input>
            </div>
            <div class="phomeCode" v-if="phomeCodeShow" @click="getCode">
                  发送验证码</div
            >
            <div class="phomeCode1" v-else> {{ counts }}s</div>
          </div>
      </div> -->
        <div v-if="yzm">
          <div class="mobile item" style="width: 70%;position: relative;">
            <p>验证码</p>
            <input
              type="text"
              name
              placeholder="请输入验证码"
              v-model="phoneNum"
            />
          </div>

          <div class="djs" v-if="phomeCodeShow" @click="getCode()">
            发送验证码
          </div>
          <div class="djs1" v-else>{{ counts }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("m.common.cancelBtn")
        }}</el-button>
        <el-button type="primary" :loading="btnLoading" @click="editOkBtn">{{
          $t("m.common.define")
        }}</el-button>
      </span>
    </el-dialog>
    <div
      id="interpret3"
      v-if="isnew == 1 && (isreimburseNum == 1 || isreimburseNum == 2)"
    >
      <el-dialog
        center
        title="员工自助体检申报"
        :visible.sync="tjMsg"
        :before-close="handleDialogClose"
      >
        <p
          style="color:#333;font-size:16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight:600"
        >
          亲爱的用户，您好！
        </p>
        <p
          style="line-height:28px;font-family: PingFangSC-Semibold, PingFang SC;color:#333;font-weight:600;margin-top:8px;font-size:16px"
        >
          您当前所在城市暂未覆盖体检机构，可自行至体检医院/机构完成体检，检后持票据在本预约平台选择【个人中心】-【在线报销】处申请报销；或利用出差/休假等机会在本平台【本人体检】中选择意向城市完成体检。
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="konw" :loading="disAgreeLoading">知道了</el-button>
          <el-button
            type="primary"
            @click="gotoReimbursement"
            :loading="agreeLoading"
            >立即报销</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
let phoneReg = /^1[3456789]\d{9}$/;
import axios from "axios";
import manual from "./manual.vue";
import { mapActions, mapGetters } from "vuex";
import { QYconfig } from "../../utils/qiyukf";
import header from "../common/header.vue";
import footer from "../common/footer.vue";
import handlePeople from "../common/handlePeople.vue";
import { selectOne, config  } from "../../utils/api";

export default {
  name: "phyExService",
  data() {
    return {
      lang: localStorage.getItem("lang"),
      projectVisible: false,
      projectRadio: null,
      projectList: [],
      name: "",
      show: true,
      isMobile: false,
      counts: "",
      timer: null,
      url: "",
      fullscreenLoading: false,
      showMsg: {},
      dialogVisible: false,
      btnLoading: false,
      sexRadio: "",
      reportVisible: false,
      disAgreeLoading: false,
      agreeLoading: false,
      rest_amount: "",
      staff_benefit_is_used: false,
      early_bird: null,
      company: "",
      contacttel: null, //手机号
      marriage: 2, //婚否情况 0未婚 1已婚
      userMsg: false, //信息确认弹框
      oneUser: {},
      userMessage: true,
      batch: "",
      num: 0, //家属权益次数
      phoneNum: null,
      phomeCodeShow: true,
      phomeCode: "",
      phone: null,
      yzm: false,
      batch: null,
      cardId: null,
      invoice_power: null,
      tjMsg: true,
      isreimburseNum: null,
      isnew: null,
      selforder:null,
      familyBtach:null,
      status:""
    };
  },
  watch: {
    "showMsg.contacttel": {
      handler: function() {
        if (
          JSON.parse(sessionStorage.getItem("userMsg")).contacttel ===
          this.showMsg.contacttel
        ) {
          this.yzm = false;
        } else {
          // console.log(7987897)
          this.yzm = true;
        }
      }
    }
  },

  components: {
    "v-header": header,
    "v-footer": footer,
    "v-manual": manual,
    "v-handlePeople": handlePeople
  },
  created() {
    config().then(res => {
        if(res.data.success){
            sessionStorage.setItem("settings", JSON.stringify(JSON.parse(res.data.data.settings)))
        }
    })
    let _this = this;
    _this.fullscreenLoading = true;
    axios
      .get(BASE_URL + "/exam/report/authorize/")
      .then(res => {
        if (res.data.data.is_first) {
          _this.reportVisible = true;
        }
        _this.getPhysical();
        _this.exchange_amount();
      })
      .catch(err => {
        _this.fullscreenLoading = false;
      });

    axios
      .get(BASE_URL + "/exam/invoice/check/")
      .then(res2 => {
        this.fullscreenLoading = false;
        this.invoice_power = res2.data.data.invoice_power;
      })
      .catch(err => {
        this.fullscreenLoading = false;
      });
    this.isReimburse();
    axios
      .get(BASE_URL + "/exam/newuser/")
      .then(res2 => {
        this.isnew = res2.data.data.isnew;
      })
      .catch(err => {
        this.fullscreenLoading = false;
      });
        axios
        .get(BASE_URL + "/exam/projects/")
        .then(res3 => {
          // console.log(res3)
          sessionStorage.setItem('project',JSON.stringify(res3.data.data[0]))
        })
  },
  async mounted() {
    let _this = this;
    await axios.get(BASE_URL + "/exam/projects/").then(res => {
      axios
        .get(
          BASE_URL + `/exam/project/staff_info/?code=${res.data.data[0].code}`
        )
        .then(res => {
          this.status = res.data.data.status
          this.early_bird = res.data.data.early_bird;
          this.company = res.data.data.company;
          this.batch = res.data.data.batch;
          this.familyBtach = res.data.data.relative_batch
          this.num = res.data.data.combo_balance_count;
          sessionStorage.setItem(
            "self_paid_packages_total_count",
            res.data.data.self_paid_packages_total_count
          );
          sessionStorage.setItem("staff_info", JSON.stringify(res.data.data));
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    });
    // axios.get(BASE_URL + "/exam/selforder/").then(res => {
    //   this.selforder = res.data.data.selforder
    // })
    // _this.selectOne();
  },
  methods: {
    isReimburse() {
      axios
        .get(BASE_URL + "/exam/invoice/check/")
        .then(res2 => {
          this.fullscreenLoading = false;
          this.isreimburseNum = Number(res2.data.data.invoice_power);
        })
        .catch(err => {
          this.fullscreenLoading = false;
        });
    },
    handleDialogClose() {
      axios
        .post(BASE_URL + "/exam/newuser/")
        .then(res2 => {
          this.isnew = res2.data.data.isnew;
        })
        .catch(err => {
          this.fullscreenLoading = false;
        });
      this.tjMsg = false;
    },
    konw() {
      this.handleDialogClose();
    },
    gotoReimbursement() {
      this.handleDialogClose();
      this.$router.push("/reimburse");
    },
    ...mapActions(
      // 语法糖
      ["message"] // 相当于this.$store.dispatch('modifyName'),提交这个方法
    ),
    // exchange_amount() {
    //   let _this = this;
    //   _this.fullscreenLoading = false;
    //   axios
    //     .get(BASE_URL + "/exam/abb/card/exchange_amount/")
    //     .then(res => {
    //       _this.rest_amount = res.data.data.rest_amount;
    //       _this.fullscreenLoading = false;
    //       _this.staff_benefit_is_used = res.data.data.staff_benefit_is_used;
    //     })
    //     .catch(err => {
    //       _this.fullscreenLoading = false;
    //     });
    // },
    // 获取验证码
    getCode() {
      if (!this.showMsg.contacttel) {
        this.$message({
          message: "请填写手机号",
          type: "error",
          center: true
        });
      } else if (!phoneReg.test(this.showMsg.contacttel)) {
        this.$message({
          message: "请填写正确的手机号",
          type: "error",
          center: true
        });
      } else {
        let _this = this;
        axios
          .post(BASE_URL + `/exam/relatives/update/token/`, {
            mobile: this.showMsg.contacttel,
            project: JSON.parse(sessionStorage.getItem("project")).id
          })
          .then(res => {
            let TIME_COUNT = 60;
            if (!_this.timer) {
              _this.counts = TIME_COUNT;
              _this.phomeCodeShow = false;
              _this.timer = setInterval(() => {
                if (_this.counts > 0 && _this.counts <= TIME_COUNT) {
                  _this.counts--;
                } else {
                  _this.phomeCodeShow = true;
                  clearInterval(_this.timer);
                  _this.timer = null;
                }
              }, 1000);
            }
          });
      }
    },
    //判断员工是否为高管
    isVip() {},
    //点击查看授权报告
    reportXY() {
      window.open("../../../static/pdf/用户授权协议.pdf");
    },
    //不同意授权报告
    disAgreeBtn() {
      let _this = this;
      _this.disAgreeLoading = true;
      _this.reportSQ(0);
    },
    //体检报告
    tjbg() {
      let _this = this;
      _this.$router.push({
        path: "/medicalReports"
      });
    },

    //同意授权报告
    agreeBtn() {
      let _this = this;
      _this.agreeLoading = true;
      _this.reportSQ(1);
    },
    reportSQ(isAgree) {
      let _this = this;
      axios
        .post(BASE_URL + "/exam/report/authorize/", {
          report_authorize: isAgree
        })
        .then(res => {
          _this.disAgreeLoading = false;
          _this.agreeLoading = false;
          _this.reportVisible = false;
        })
        .catch(err => {});
    },
    //点击编辑员工信息弹框的确定
    editOkBtn() {
      let _this = this;
      console.log(_this.marriage);
      let phoneReg = /^1[3456789]\d{9}$/;
      if (
        JSON.parse(sessionStorage.getItem("userMsg")).contacttel !=
        this.showMsg.contacttel
      ) {
        if (_this.phoneNum == null) {
          let data = {
            message: "请输入验证码",
            type: "error",
            center: true
          };
          _this.message(data);
        }
      }
       if (_this.showMsg.contacttel == "") {
        let data = {
          message: _this.$t("m.staffMsg.editDialog.errMsg.phone"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (!phoneReg.test(_this.showMsg.contacttel)) {
        let data = {
          message: _this.$t("m.staffMsg.editDialog.errMsg.okPhone"),
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.showMsg.birthday == "") {
        let data = {
          message: "请选择出生日期",
          type: "error",
          center: true
        };
        _this.message(data);
      } else if (_this.marriage == 2 && _this.showMsg.gender_value === "女") {
        let data = {
          message: "请选择婚姻状况",
          type: "error",
          center: true
        };
        _this.message(data);
      } else {
        _this.btnLoading = true;
        axios
          .post(BASE_URL + "/exam/relatives/update/mobile/", {
            mobile: _this.showMsg.contacttel,
            marriage: _this.marriage == 2 ? 1 : _this.marriage,
            token: _this.phoneNum,
            birthday: _this.showMsg.birthday,
            project: JSON.parse(sessionStorage.getItem("project")).id
          })
          .then(res => {
            _this.btnLoading = false;
            _this.dialogVisible = false;
            _this.$message.success("修改成功");
            _this.getPhysical();
            // if (this.early_bird == 1) {
            //   _this.$router.push({
            //     path: "/earlyBird",
            //     query: {
            //       type: "staff",
            //       batch: _this.batch,
            //       cardId: _this.cardId,
            //       toothBenefit: _this.toothBenefit
            //     }
            //   });
            // } else {
              _this.$router.push({
                path: "/writeSubscribe",
                query: {
                  type: "staff",
                  batch: _this.batch,
                  cardId: res1.data.data.id
                }
              });
            // }
          })
          .catch(err => {
            _this.btnLoading = false;
          });
      }
    },
    //获取体检人列表
    getPhysical() {
      let _this = this;
      // _this.fullscreenLoading = true;
      axios
        .get(BASE_URL + "/exam/relatives/")
        .then(res => {
          _this.fullscreenLoading = false;
          res.data.data.forEach(function(element) {
            if (element.relationship === 0) {
              _this.showMsg = element;
              sessionStorage.setItem("userMsg", JSON.stringify(element));
            }
          });
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    },
    //查看是否有订单
    getSelfOrder() {
      let _this = this;
      axios.get(BASE_URL + "/exam/selforder/").then(res => {
        this.selforder = res.data.data.selforder
        if (res.data.data.selforder == 0) {
          _this.$router
            .push({
              path: "/writeSubscribe",
              query: {
                type: "staff",
                batch: _this.batch
              }
            })
            .catch(err => {
              this.fullscreenLoading = false;
            });
        } else {
          _this.$message({
            message: _this.$t("m.common.warnMsg"),
            type: "error",
            center: true
          });
        }
      });
    },
    //本人信息
    selectOne() {
      selectOne().then(res => {
        alert(res);
        if (res.data.code == 10000) {
          this.oneUser = res.data.data;
          sessionStorage.setItem("oneUser", JSON.stringify(res.data.data));
        }
      });
    },
    dialogVisibles_add(data) {
      console.log(data);
      this.userMsg = data;
      // this.selectOne()
    },

    //获取项目信息
    getProject() {
      let _this = this;
      // var contacttelPhone = JSON.parse(sessionStorage.getItem("userMsg"));
      // if ((!contacttelPhone.contacttel || (contacttelPhone.identity_type !== 0 && !contacttelPhone.birthday)) && this.flag == 0) {
      //     _this.projectVisible = true;
      //     this.userName = contacttelPhone.name;
      //     this.userSex = contacttelPhone.gender_value;
      //     this.handleCommand(contacttelPhone.identity_type);
      //     this.idCardNum = contacttelPhone.identity_code;
      //     this.contacttel = contacttelPhone.contacttel;
      //     this.birthday = contacttelPhone.birthday
      // } else {
      //     this.getSelfOrder();
      // }
      //获取项目信息接口
      axios
        .get(BASE_URL + "/exam/projects/")
        .then(res => {
          _this.fullscreenLoading = false;
          if (res.data.data.length > 1) {
            _this.projectVisible = true;
            _this.projectList = res.data.data;
          } else {
            _this.projectList = res.data.data[0];
            let project = JSON.stringify(_this.projectList);
            sessionStorage.setItem("project", project);
            _this.sexRadio = _this.showMsg.gender;
            // _this.marriage = _this.showMsg.marriage
            if (
              !_this.showMsg.contacttel ||
              _this.showMsg.contacttel == "" ||
              _this.showMsg.marriage == 2 
            ) {
              _this.dialogVisible = true;
              // _this.userMsg = true
            } else {
              let family = "";
              if (_this.name == "dependents") {
                family = "&card_type=relative";
              }
              let projectId = JSON.parse(sessionStorage.getItem("project")).id;
              axios
                .get(
                  BASE_URL +
                    `/exam/relatives/benefit/?project=${projectId}${family}`,
                  {}
                )
                .then(res1 => {
                  this.batch = res1.data.data.batch;
                  this.familyBtach= res1.data.data.relative_batch
                  this.cardId = res1.data.data.id;
                  if (_this.name == "staff") {
                    axios
                      .post(BASE_URL + "/exam/relatives/personal/")
                      .then(res => {
                        this.contacttel = res.data.data.contacttel;
                        this.oneUser = res.data.data;
                        sessionStorage.setItem(
                          "oneUser",
                          JSON.stringify(res.data.data)
                        );

                        // if (this.early_bird == 1) {
                        //   _this.$router.push({
                        //     path: "/earlyBird",
                        //     query: {
                        //       type: "staff",
                        //       batch: res1.data.data.batch,
                        //       cardId: res1.data.data.id,
                        //       toothBenefit: this.toothBenefit
                        //     }
                        //   });
                        // } else {
                          _this.$router.push({
                            path: "/writeSubscribe",
                            query: {
                              type: "staff",
                              batch: res1.data.data.batch,
                              cardId: res1.data.data.id
                            }
                          });
                        // }
                      });
                  } 
                  // else {
                  //   _this.name == "dependents";
                  //   _this.$router.push({
                  //     path: "/familyMembers",
                  //     query: {
                  //       type: "dependents",
                  //       batch: res1.data.data.batch,
                  //       cardId: res1.data.data.id
                  //     }
                  //   });
                  // }
                });
            }
          }
        })
        .catch(err => {
          _this.fullscreenLoading = false;
        });
    },
    //点击选择项目名称的弹窗的确定
    projectOkBtn() {
      let _this = this;
      if (_this.projectRadio != null) {
        _this.projectVisible = false;
        let project = JSON.stringify(_this.projectList[_this.projectRadio]);
        sessionStorage.setItem("project", project);
        if (_this.name == "staff") {
          _this.$router.push({
            path: "/writeSubscribe",
            query: {
              type: "staff"
            }
          });
        } else if (_this.name == "dependents") {
          _this.$router.push({
            path: "/writeSubscribe",
            query: {
              type: "dependents"
            }
          });
        }
      } else {
        let data = {
          message: _this.$t("m.phyIndex.errorChoose"),
          type: "error",
          center: true
        };
        _this.message(data);
      }
    },
    //预约体检本人
    appoPhysicalTJ() {
      let _this = this;
      _this.name = "staff";
      _this.fullscreenLoading = true;
      // axios.get(BASE_URL + "/exam/selforder/").then(res => {
        if (this.status == 0) {
          _this.fullscreenLoading = false;
          axios
            .get(BASE_URL + "/exam/invoice/check/")
            .then(res2 => {
              this.fullscreenLoading = false;
              this.invoice_power = res2.data.data.invoice_power;
              if (res2.data.data.invoice_power == 2) {
                _this.$message({
                  message: res2.data.data.invoice_power_value,
                  type: "error",
                  center: true
                });
              } else {
                _this.getProject();
              }
            })
            .catch(err => {
              this.fullscreenLoading = false;
            });
        } else if(this.status == 1){
          _this.fullscreenLoading = false;
          _this.$message({
            message: "您报名线下体检，系统内体检权限暂时冻结",
            type: "error",
            center: true
          });
        } else if(this.status == 2){
          _this.fullscreenLoading = false;
          _this.$message({
            message: "您已预约体检",
            type: "error",
            center: true
          });
        } else if(this.status == 3){
          _this.fullscreenLoading = false;
          _this.$message({
            message: "暂无体检权益",
            type: "error",
            center: true
          });
        }
      // });
    },
    //家属体检
    dependentsTJ() {
      let _this = this;
      _this.name = "dependents";
      _this.fullscreenLoading = true;
      _this.$router.push({
        path: "/familyMembers",
        query: {
          type: "dependents",
          batch: _this.familyBtach,
        }
      });
    },
    //体检订单
    tjOrder() {
      let _this = this;
      _this.$router.push({
        path: "/phyOrderList",
        query: {
          check: 0,
          statusType: 0
        }
      });
    },
    //体检报告
    tjPDF() {
      axios.get(BASE_URL + "/exam/account/profile/").then(res => {
        QYconfig({
          uid: res.data.data.user_id + "jkzx",
          name: res.data.data.realname,
          data: JSON.stringify([
            {
              key: "projectName",
              label: "项目名称",
              value: "ABB"
            },
            {
              key: "source",
              label: "来源",
              value: "健康咨询"
            }
          ])
        });
      });
    },
    ...mapActions(
      // 语法糖
      ["message"] // 相当于this.$store.dispatch('modifyName'),提交这个方法
    )
  },
  computed: {
    ...mapGetters(["allUserMsg", "qhText"])
  }
};
</script>

<style scoped>
.reportMsg .titName {
  display: flex;
}

.reportMsg .msg1 p,
.reportMsg .msg2 p {
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  text-align: justify;
}

.reportMsg .msg3 p {
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 24px;
}
/* .reportMsg .msg3 p,.reportMsg .msg2 p{
		font-size:18px;
		color:#333;
		line-height:30px;
		text-align: justify;
    width: 100%;
	} */

.reportMsg .msg3 p {
  margin-top: 5px;
}

.reportMsg .msg2 p {
  font-weight: bold;
}

.reportMsg .msg2 p span {
  color: #e94709;
  cursor: pointer;
  text-decoration: underline;
}

.reportMsg .titName .icon {
  width: 4px;
  height: 20px;
  background: #e94709;
}

.reportMsg .titName .name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  line-height: 20px;
  margin-left: 7px;
}

#dsy {
  width: 58px;
  height: 29px;
  position: absolute;
  z-index: 10;
  /* left: 141px; */
  right: -25px;
  top: -20px;
}

.staffEn {
  padding: 0 10px;
}

.reportEn {
  padding: 0 20px;
}

.suggestionEn {
  padding: 0 30px;
}

.getcode {
  width: 92px;
  height: 30px;
  background: #999999;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  line-height: 16px;
  margin-right: 10px;
  cursor: pointer;
}

.editMsg {
  width: 100%;
}

.editMsg .item {
  width: 100%;
  height: 50px;
  border: 1px solid #dfdfdf;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.editMsg .item p:first-child {
  width: 104px;
  text-align: center;
  /*padding: 17px 20px;*/
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
}

.editMsg .item p:last-child {
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.editMsg .item input {
  width: 60%;
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.editMsg .item .radioDiv {
  width: 60%;
  height: 30px;
  font-size: 16px;
  font-weight: 400;
  color: #333;
  line-height: 16px;
  display: flex;
  align-items: center;
  border-left: 1px solid #dfdfdf;
  padding-left: 20px;
}

.projectMsg {
  display: flex;
}

.projectMsg .tit {
  width: 120px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #999;
  line-height: 16px;
}

.projectMsg div {
  display: flex;
  flex-direction: column;
}

.projectMsg div p {
  margin-bottom: 10px !important;
}

.banner {
  width: 100%;
  /*height: 260px;*/
  min-width: 1180px;
  /*background: url(../../assets/tjBanner.png) no-repeat center top;*/
}

.banner img {
  width: 100%;
  min-width: 1180px;
}

.mod {
  width: 940px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}

.appoPhysical {
  width: 110px;
  height: 135px;
  /* background: #ffffff; */
  /* box-shadow: 0px 0px 30px 0px rgba(197, 197, 197, 0.35); */
  /* border-radius: 1px; */
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.appoPhysical .icon {
  width: 110px;
  height: 110px;
  margin: 0 auto;
}

.appoPhysical .icon > img {
  width: 110px;
  height: 110px;
}

.appoPhysical .modName {
  margin-top: 20px;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  line-height: 24px;
  text-align: center;
}

.msg {
  width: 1180px;
  margin: 0 auto;
}

.msg h3 {
  font-size: 30px;
  font-weight: bold;
  color: #333;
  line-height: 30px;
  text-align: center;
  margin-top: 40px;
}

.msg p {
  font-size: 20px;
  font-weight: 400;
  color: #333;
  line-height: 36px;
  margin-top: 30px;
  padding: 0 50px;
  margin-bottom: 44px;
  text-align: justify;
}

.yzm {
  width: 100%;
  height: 50px;
  margin-bottom: 20px;
}

.left {
  float: left;
  width: 30%;
  border-radius: 8px;
  height: 50px;
  border: solid 1px #ccc;
}

.left > input {
  float: left;
  width: 60%;
  height: 50px;
  padding-left: 20px;
}

.phomeCode {
  cursor: pointer;
  width: 92px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: inline-block;
  margin-left: 10px;
  color: #fff;
  background: #ff000f;
  border-radius: 4px;
}

.djs {
  width: 20%;
  height: 50px;
  position: absolute;
  bottom: 123px;
  text-align: center;
  background: #ff000f;
  line-height: 50px;
  border-radius: 5px;
  color: #fff;
  right: 35px;
}

.djs1 {
  width: 20%;
  height: 50px;
  position: absolute;
  bottom: 123px;
  text-align: center;
  background: #c5c5c5;
  line-height: 50px;
  border-radius: 5px;
  color: #fff;
  right: 35px;
}

.phomeCode1 {
  cursor: pointer;
  width: 92px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: inline-block;
  margin-left: 10px;
  color: #fff;
  background: #c5c5c5;
  border-radius: 4px;
}
.ts {
  padding-left: 105px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/phyExServices/phyExServices.vue